import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaLock, FaEnvelope, FaCheckCircle, FaShieldAlt, FaChartPie } from 'react-icons/fa';
import financeApi, { setFinanceToken, setFinanceUser } from './api';
import PasswordInput from './PasswordInput';
import logo from '../assets/logo_v3.png';
import financeHero from './assets/finance-hero.svg';
import './FinanceLogin.css';

export default function FinanceLogin() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await financeApi.post('/finance/auth/login', form);
      if (response.data?.status?.statusCode === 'code-200') {
        const { token, user } = response.data.data;
        setFinanceToken(token);
        setFinanceUser(user);
        navigate('/finance/dashboard');
      } else {
        setError(response.data?.status?.statusMessage || 'Login failed');
      }
    } catch (err) {
      setError(err.response?.data?.status?.statusMessage || 'Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="finance-login-page">
      <div className="finance-login-brand">
        <div className="finance-login-brand-content">
          <img src={logo} alt="Cleanz24" className="finance-login-brand-logo" />
          <h1>Finance Portal</h1>
          <p>Secure internal finance management for collections, expenses, and reporting.</p>
          <div className="finance-login-brand-features">
            <div className="finance-login-brand-feature"><FaChartPie /> Company & cash ledger tracking</div>
            <div className="finance-login-brand-feature"><FaCheckCircle /> Franchise-wise reports & exports</div>
            <div className="finance-login-brand-feature"><FaShieldAlt /> Role-based admin & employee access</div>
          </div>
        </div>
        <img src={financeHero} alt="" className="finance-login-hero-art" aria-hidden="true" />
      </div>
      <div className="finance-login-main">
        <div className="finance-login-card">
          <div className="finance-login-header">
            <img src={logo} alt="" className="finance-login-card-logo" aria-hidden="true" />
            <h1>Welcome back</h1>
            <p>Sign in with your admin or employee account</p>
          </div>

          {error && <div className="finance-error">{error}</div>}

          <form onSubmit={handleSubmit} className="finance-login-form">
            <div className="finance-login-field">
              <FaEnvelope />
              <input
                type="email"
                name="email"
                placeholder="Email address"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="finance-login-field">
              <FaLock />
              <PasswordInput
                className="finance-password-login"
                name="password"
                placeholder="Password"
                value={form.password}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>
            <button type="submit" className="finance-login-btn" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
